import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Typography,
  Button,
} from '@material-ui/core';
import {
  MyPATTextArea,
  MyPATTextField,
  MyPATExpansionPanel,
  dateService,
  MyPATMathField,
  ModalComponent,

} from '../../../common';
import { statusType } from '../../types/ContentInSection'
import AddExtraTags from './AddExtraTags';
import AddDifficultyAndSkill from './AddDifficultyAndSkill';
import AddConceptOrChapter from './AddConceptOrChapter';
import ContentFormData from '../../types/ContentFormData';
import ContentFormDataError from '../../types/ContentFormDataError';
import { CreateContentContentTagData } from '../../types/ContentTagData';
import { eventFired } from '../../actions/contentInSectionAction'
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import contentActions from '../../actions/contentActions';


const styles = (theme: Theme) => createStyles({
  cardHeading: {
    fontWeight: theme.typography.fontWeightRegular,
  },
  requiredHeading: {
    color: theme.palette.secondary.main,
  },
  mb1x: {
		marginBottom: theme.spacing.unit
	},
  paddingSet:{
    padding:'0 15px 0 0',
  },
  popupBlock:{
    width:'450px',
    textAlign:'center',
    '& p':{
      fontSize:'16px',
      'font-weight': 'normal',
      lineHeight: '16px',
      textAlign: 'center',
      letterSpacing: '0.144385px',
      color: '#000000',
      display:'block',
      paddingTop:'20px',
      }
  },
  attentionTitle:{
    fontSize:'16px',
    'font-weight': '500',
    lineHeight: '15px',
    textAlign: 'center',
    letterSpacing: '0.144385px',
    color: '#000000',
    display:'block',
    paddingBottom:'18px',
    },

});

interface SampleProblemCreateProps extends WithStyles<typeof styles> {
  formData: ContentFormData,
  formDataError: ContentFormDataError,
  handleFormChange: (formData: ContentFormData) => void,
  eventFired: Function,
  type:any,
  history: any;
  updateContent: Function
}
interface SampleProblemCreateState {
  mathEditor: any,
  isOpen: boolean
}
let sections = ['studyNotes', 'conceptCode', 'tags'];

class SampleProblemCreate extends Component<SampleProblemCreateProps,SampleProblemCreateState> {
  constructor(props: SampleProblemCreateProps) {
    super(props);
    this.state = {
      mathEditor:null,
      isOpen: false,
    }
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleTagsFormChange = this.handleTagsFormChange.bind(this);
    this.handleAddConceptChapterFormChange = this.handleAddConceptChapterFormChange.bind(this);
    this.handleDifficultyAndSkillFormChange = this.handleDifficultyAndSkillFormChange.bind(this);
    this.handleClose = this.handleClose.bind(this)
  }

  componentDidMount() {
    const self = this
    /* TODO: uncomment later when data loss issue fix for all functions */
    // const {formData} = this.props
    // self.props.updateContent(formData)
		window.onbeforeunload = function (e: any) {
			const {formData} = self.props
			self.props.handleFormChange(formData)
			e.preventDefault()
			e.returnValue = ''
		}
  }

  handleInputChange(evt: any) {
    const { name, value } = evt.target;
    let { formData } = this.props;

    if (_.isUndefined(formData.content[0])) {
      formData.content.push({ [name]: value });
    } else {
      formData.content[0][name] = value;
    }

    this.props.handleFormChange(formData);

    if (['title', 'content'].includes(name))
      this.eventChanges('studyNotes');

  }

  handleAddConceptChapterFormChange(updateFormData: any) {
    let { formData } = this.props;
    formData.subjects = updateFormData;
    this.props.handleFormChange(formData);
    this.eventChanges("conceptCode");

  }

  handleDifficultyAndSkillFormChange(difficulty: string, skill: string) {
    let { formData } = this.props;
    formData.difficultyLevel = difficulty;
    formData.difficultyType = skill;
    this.props.handleFormChange(formData);
  }

  handleTagsFormChange(tagsFormData: CreateContentContentTagData[], evt: any) {
    let { formData } = this.props;
    formData.tags = tagsFormData;
    this.props.handleFormChange(formData);
    this.eventChanges('tags');

  }

  eventChanges(name: any) {
    if (sections.includes(name))
      this.props.eventFired(name, statusType.edit, 0, 0);
  }
  setMathInstance = (mathEditor:any) => {
    this.setState({ mathEditor })
  }
  
  handleClose = () => {
    const {history} = this.props
		history.push("/");
	}


  render() {
    const { classes, formData, formDataError,type  } = this.props;
    const { content, subjects, tags } = formData;
    const lockData = _.get(formData, 'lockData')
    let isLock = false
    let message = ''
    if(lockData) {
       isLock = lockData.isLock
       message = lockData.message
    }


    return (
      <>
        <MyPATExpansionPanel
          hasExpandIcon={false}
          variant="white"
          customCollapseTitle={
            <Typography variant="h6" className={classes.cardHeading}>
              Sample Problem<span className={classes.requiredHeading}>*</span>
            </Typography>
          }
        >
          <MyPATMathField
            gridSize={12}
            editorProps={{
              externalToolbarId: 'box',
              name: 'title',
              value: _.isUndefined(content[0]) ? '' : content[0].title,
              editorId: 'title',
              handleChange: this.handleInputChange.bind(this),
              setInstance: this.setMathInstance,
            }}
          />
          <MyPATMathField
						variant='textarea'
						editorProps={{
							externalToolbarId: 'box',
							name: "content",
							handleChange: this.handleInputChange.bind(this),
              setInstance: this.setMathInstance,
							editorId: "createContent",
							value : _.isUndefined(content[0]) ? '' : content[0].content
						}} 
					/>
          {/* <MyPATTextField
            name="title"
            value={_.isUndefined(content[0]) ? '' : content[0].title}
            onChange={this.handleInputChange.bind(this)}
            placeholder="Title here..."
            fullWidthControl
            error={formDataError['title'].error}
            errorText={formDataError['title'].errorText}
          /> */}
          {/* <MyPATTextArea
            inputId="createQuestion"
            name="content"
            value={_.isUndefined(content[0]) ? '' : content[0].content}
            onChange={this.handleInputChange.bind(this)}
            placeholder="Write here..."
            rows="5"
            multiline
            fullWidthControl
            error={formDataError['content'].error}
            errorText={formDataError['content'].errorText}
          /> */}
          <Typography variant="caption" align="right" color="textSecondary">
            Draft saved: {dateService.dateTime(formData.updatedAt)}
          </Typography>
        </MyPATExpansionPanel>

        <AddConceptOrChapter
          formData={subjects}
          handleFormChange={this.handleAddConceptChapterFormChange.bind(this)}
          error={formDataError['subjects'].error}
          errorText={formDataError['subjects'].errorText}
        />

        <AddDifficultyAndSkill
          defaultExpanded={false}
          formData={formData}
          handleFormChange={this.handleDifficultyAndSkillFormChange.bind(this)}
        />

        <AddExtraTags
          isRequired
          formData={tags}
          handleFormChange={this.handleTagsFormChange.bind(this)}
          error={formDataError['tags'].error}
          errorText={formDataError['tags'].errorText}
          contentType = {type}
          defaultExpanded={true}
        />
        {
					  isLock ? (
						<ModalComponent
						component={() => (
							<>
							<MuiDialogContent className={classes.paddingSet}>
							<div className={classes.popupBlock}>
              <b className={classes.attentionTitle}>Attention</b>
              <img src="https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/cms/attention.png" alt="Attention" />
              <p>{message}</p>
              </div>
              <div style={{'textAlign':'right'}}>
              <Button autoFocus
              variant="contained"
              color="primary"
              onClick={this.handleClose}>
                OK
              </Button>
							</div>
						  </MuiDialogContent>
						  <MuiDialogActions></MuiDialogActions>
							</>
						)}
						/>
					  ) : ''
				  }
      </>
    );
  }
};

const mapStateToProps = (state: any) => ({

});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  eventFired,
  updateContent: contentActions.updateContent,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SampleProblemCreate));